/**
 * - このコンポーネントは他のnext/headコンポーネントの中でネストして使用しない。
 *   ネストするとページレンダリング時に本コンポーネントが消失するため。
 * - 親コンポーネントでnext/headを使用し、本コンポーネントからはscriptタグのみreturnした場合、scriptタグが正しくレンダリングされない。
 *   そのため親コンポーネントではnext/headを使用せず、本コンポーネントからはnext/headとscriptタグをセットでreturnする。
 */
import NextHead from 'next/head';

type StructuredData = {
  '@context'?: string;
  '@type': string;
  [key: string]: any;
};

type JsonLdProps = {
  data: StructuredData | StructuredData[];
};

export const JsonLd = ({ data }: JsonLdProps) => {
  const jsonLd = Array.isArray(data)
    ? data.map(createJsonLd)
    : createJsonLd(data);

  return (
    <NextHead>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
    </NextHead>
  );
};

const createJsonLd = (item: StructuredData) => {
  const {
    '@context': context = 'https://schema.org',
    '@type': type,
    ...props
  } = item;
  return {
    '@context': context,
    '@type': type,
    ...props,
  };
};
